'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHashedString = getHashedString;

var _sha256Js = require('sha-256-js');

var _sha256Js2 = _interopRequireDefault(_sha256Js);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This module simply takes the ordinary string and hashes it to SHA256 string.
 * Primary usage of this module is serialization of emails, which should be sent
 * to the adtriba service later on. This service is supposed to help marketing
 * to define whether this customer with particular email has already visit our 
 * website or not, and if the email matches - it will count 2 visits made by the
 * same customer as one visit, and marketing metrics will be more accurate.
 * For additional information see WEB-289.
 */

/**
 * This function recieves an email as an argument and returns SHA256 serialized 
 * string.
 */
function getHashedString(str) {
  return (0, _sha256Js2.default)(str);
}